module.exports = __webpack_public_path__ + "img/1_007.008bdf7d.jpg";